import { parseNum } from "./dgiiUtils";

const MoneyInput = ({ value, onChange, readOnly, total, center, testId }) => (
  <input
    className={`dgii-input ${total ? "total-input" : ""}`}
    style={center ? { textAlign: "center" } : undefined}
    value={value || ""}
    readOnly={readOnly}
    onChange={(e) => onChange(e.target.value)}
    onBlur={(e) => {
      if (e.target.value !== "") {
        onChange(parseNum(e.target.value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      }
    }}
    data-testid={testId}
  />
);

// Secciones con CANTIDAD + MONTO (II) [n, label, qtyK, op, montoK, total]
const SEC2 = [
  [1, "COMPROBANTES VÁLIDO PARA CRÉDITO FISCAL (01 Y 31)", "cas001", "+", "cas101"],
  [2, "COMPROBANTES DE CONSUMO (02 Y 32)", "cas002", "+", "cas102"],
  [3, "COMPROBANTES NOTA DE DÉBITO (03 Y 33)", "cas003", "+", "cas103"],
  [4, "COMPROBANTES NOTA DE CRÉDITO (04 Y 34)", "cas004", "-", "cas104"],
  [5, "COMPROBANTES REGISTRO ÚNICO DE INGRESOS (12)", "cas005", "+", "cas105"],
  [6, "COMPROBANTES REGISTRO REGIMENES ESPECIALES (14 Y 44)", "cas006", "+", "cas106"],
  [7, "COMPROBANTES GUBERNAMENTALES (15 Y 45)", "cas007", "+", "cas107"],
  [8, "COMPROBANTES PARA EXPORTACIONES (16 Y 46)", "cas008", "+", "cas108"],
  [9, "OTRAS OPERACIONES (POSITIVAS)", "cas009", "+", "cas109"],
  [10, "OTRAS OPERACIONES (NEGATIVAS)", "cas010", "-", "cas110"],
];

// Secciones con MONTO único [n, label, op, montoK]
const SEC3 = [
  [12, "EFECTIVO", "+", "cas112"],
  [13, "CHEQUE / TRANSFERENCIA", "+", "cas113"],
  [14, "TARJETA DÉBITO / CRÉDITO", "+", "cas114"],
  [15, "A CRÉDITO", "+", "cas115"],
  [16, "BONOS O CERTIFICADO DE REGALO", "+", "cas116"],
  [17, "PERMUTAS", "+", "cas117"],
  [18, "OTRAS FORMAS DE VENTA", "+", "cas118"],
];
const SEC4 = [
  [20, "INGRESOS POR OPERACIONES (NO FINANCIEROS)", "+", "cas120"],
  [21, "INGRESOS FINANCIEROS", "+", "cas121"],
  [22, "INGRESOS EXTRAORDINARIOS", "+", "cas122"],
  [23, "INGRESOS POR ARRENDAMIENTOS", "+", "cas123"],
  [24, "INGRESOS POR VENTAS DE ACTIVOS DEPRECIABLES", "+", "cas124"],
  [25, "OTROS INGRESOS", "+", "cas125"],
];
const SEC5 = [
  [27, "PAGOS COMPUTABLES POR RETENCIONES (Norma No. 08-04)", "+", "cas127"],
  [28, "PAGOS COMPUTABLES POR VENTAS DE PASAJES DE TRANSPORTE AÉREO (Norma No. 02-05) (BSP-IATA)", "+", "cas128"],
  [29, "PAGOS COMPUTABLES POR OTRAS RETENCIONES (Norma No. 02-05)", "+", "cas129"],
  [30, "PAGOS COMPUTABLES POR VENTAS DE PAQUETES DE ALOJAMIENTO Y OCUPACIÓN", "+", "cas130"],
  [31, "CRÉDITO POR RETENCIÓN REALIZADA POR ENTIDADES DEL ESTADO", "+", "cas131"],
  [32, "PAGOS COMPUTABLES POR ITBIS PERCIBIDO", "+", "cas132"],
];
const SEC8 = [
  [43, "TOTAL NOTAS DE CRÉDITO EMITIDAS CON MÁS DE TREINTA (30) DÍAS DESDE LA FACTURACIÓN (Art. 338 CT)", "=", "cas143"],
  [44, "TOTAL FACTURAS EN COMPROBANTES FISCALES PARA REGIMENES ESPECIALES (Proviene del Formato 606)", "=", "cas144"],
];

// Sección IX [n, label, comprasK, servK, impK, totalK, total]
const SEC9_A = [
  [45, "EN OPERACIONES DE PRODUCTORES DE BIENES O SERVICIOS EXENTOS", "cas045", "cas145", "cas245", "cas345"],
  [46, "A INCLUIR EN ACTIVOS (CATEGORÍA I)", "cas046", "cas146", "cas246", "cas346"],
  [47, "OTROS ITBIS PAGADOS NO DEDUCIBLES", "cas047", "cas147", "cas247", "cas347"],
  [48, "TOTAL ITBIS NO DEDUCIBLE (45+46+47)", "cas048", "cas148", "cas248", "cas348", true],
];
const SEC9_B = [
  [49, "EN LA PRODUCCIÓN Y/O VENTA DE BIENES EXPORTADOS", "cas049", "cas149", "cas249", "cas349"],
  [50, "EN LA PRODUCCIÓN Y/O VENTA DE BIENES GRAVADOS", "cas050", "cas150", "cas250", "cas350"],
  [51, "EN LA PRESTACIÓN DE SERVICIOS GRAVADOS", "cas051", "cas151", "cas251", "cas351"],
  [52, "TOTAL ITBIS DEDUCIBLE NO SUJETO A PROPORCIONALIDAD (49+50+51)", "cas052", "cas152", "cas252", "cas352", true],
];

export default function FormularioAnexoA({ data, onChange, readOnly = false }) {
  const set = (k, v) => onChange({ ...data, [k]: v });
  const M = (k, total) => (
    <td className="money-cell"><MoneyInput value={data[k]} onChange={(v) => set(k, v)} readOnly={readOnly} total={total} testId={`anexo-${k}`} /></td>
  );

  return (
    <div id="printDocumentit1">
      <div className="dgii-form dgii-print-area" >
        <div className="fm-header">
          <div>
            <img
              src="https://www.dasoft.com.do/wp-content/themes/dasoft2.0/image/dasoft-logo.png"
              alt="DGII"
              className="dgii-logo"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
          <div>
            <h2>DECLARACIÓN JURADA Y/O PAGO DEL IMPUESTO SOBRE LAS TRANSFERENCIAS DE BIENES INDUSTRIALIZADOS Y SERVICIOS (ITBIS)</h2>
          </div>
          <div className="fm-code">
            <h2>Anexo A</h2>
            <div>(Valores en RD$)</div>
          </div>
        </div>

        <div className="dgii-header-grid" style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
          <div className="dgii-field">
            <label>RNC/Cédula</label>
            <input value={data.rnc || ""} readOnly onChange={() => { }} data-testid="anexo-rnc" />
          </div>
          <div className="dgii-field">
            <label>Razón social/Nombre</label>
            <input value={data.razon_social || ""} readOnly onChange={() => { }} />
          </div>
          <div className="dgii-field">
            <label>Período Fiscal (Año/Mes)</label>
            <input value={data.periodo || ""} readOnly onChange={() => { }} data-testid="anexo-periodo" />
          </div>
        </div>

        {/* Tabla principal secciones II - VIII (8 columnas) */}
        <table className="dgii-table" style={{ marginTop: 8 }}>
          <colgroup>
            <col style={{ width: "28px" }} />
            <col />
            <col style={{ width: "90px" }} />
            <col style={{ width: "22px" }} />
            <col style={{ width: "130px" }} />
          </colgroup>
          <tbody>
            {/* Sección II */}
            <tr>
              <td className="sec" colSpan={2}>II. OPERACIONES REPORTADAS EN EL 607, LIBRO DE VENTAS Y FACTURA ELECTRONICA (E-NCF) POR TIPO DE NCF</td>
              <td className="sec" style={{ textAlign: "center" }}>CANTIDAD</td>
              <td className="sec"></td>
              <td className="sec" style={{ textAlign: "center" }}>MONTO</td>
            </tr>
            {SEC2.map(([n, label, qty, op, monto]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className="lbl">{label}</td>
                <td className="qty-cell"><MoneyInput value={data[qty]} onChange={(v) => set(qty, v)} readOnly={readOnly} center testId={`anexo-${qty}`} /></td>
                <td className="op">{op}</td>
                {M(monto)}
              </tr>
            ))}
            <tr>
              <td className="num">11</td>
              <td className="lbl total" colSpan={2}>TOTAL OPERACIONES (Sumar casillas 1+2+3-4+5+6+7+8+9-10)</td>
              <td className="op">=</td>
              {M("cas111", true)}
            </tr>

            {/* Sección III */}
            <tr><td className="sec" colSpan={5}>III. OPERACIONES REPORTADAS POR TIPO DE VENTA (MONTO TOTAL INCLUYENDO IMPUESTOS) — MONTO BRUTO</td></tr>
            {SEC3.map(([n, label, op, monto]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className="lbl" colSpan={2}>{label}</td>
                <td className="op">{op}</td>
                {M(monto)}
              </tr>
            ))}
            <tr>
              <td className="num">19</td>
              <td className="lbl total" colSpan={2}>TOTAL OPERACIONES POR TIPO DE VENTA (Sumar casillas 12 a 18)</td>
              <td className="op">=</td>
              {M("cas119", true)}
            </tr>

            {/* Sección IV */}
            <tr><td className="sec" colSpan={5}>IV. OPERACIONES REPORTADAS POR TIPO DE INGRESO — MONTO</td></tr>
            {SEC4.map(([n, label, op, monto]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className="lbl" colSpan={2}>{label}</td>
                <td className="op">{op}</td>
                {M(monto)}
              </tr>
            ))}
            <tr>
              <td className="num">26</td>
              <td className="lbl total" colSpan={2}>TOTAL POR TIPO DE INGRESO (Sumar casillas 20 a 25)</td>
              <td className="op">=</td>
              {M("cas126", true)}
            </tr>

            {/* Sección V */}
            <tr><td className="sec" colSpan={5}>V. PAGOS COMPUTABLES POR RETENCIONES/PERCEPCIÓN — MONTO</td></tr>
            {SEC5.map(([n, label, op, monto]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className="lbl" colSpan={2}>{label}</td>
                <td className="op">{op}</td>
                {M(monto)}
              </tr>
            ))}
            <tr>
              <td className="num">33</td>
              <td className="lbl total" colSpan={2}>TOTAL PAGOS COMPUTABLES POR RETENCIONES/PERCEPCIÓN (Sumar casillas 27 a 32)</td>
              <td className="op">=</td>
              {M("cas133", true)}
            </tr>

            {/* Sección VI Constructoras */}
            <tr>
              <td className="sec" colSpan={2}>VI. OPERACIONES DE CONSTRUCTORAS</td>
              <td className="sec" style={{ textAlign: "center" }}>TOTAL FACTURADO</td>
              <td className="sec"></td>
              <td className="sec" style={{ textAlign: "center" }}>MONTO</td>
            </tr>
            <tr>
              <td className="num">34</td>
              <td className="lbl">DIRECCIÓN TÉCNICA (Art. 4 Norma 07-07)</td>
              <td className="money-cell"><MoneyInput value={data.cas034} onChange={(v) => set("cas034", v)} readOnly={readOnly} testId="anexo-cas034" /></td>
              <td className="op">+</td>
              {M("cas134")}
            </tr>
            <tr>
              <td className="num">35</td>
              <td className="lbl">CONTRATO DE ADMINISTRACIÓN (Art. 4 Párrafo I, Norma 07-07)</td>
              <td className="money-cell"><MoneyInput value={data.cas035} onChange={(v) => set("cas035", v)} readOnly={readOnly} testId="anexo-cas035" /></td>
              <td className="op">+</td>
              {M("cas135")}
            </tr>
            <tr>
              <td className="num">36</td>
              <td className="lbl" colSpan={2}>ASESORIAS / HONORARIOS</td>
              <td className="op">+</td>
              {M("cas136")}
            </tr>
            <tr>
              <td className="num">37</td>
              <td className="lbl total">TOTAL OPERACIONES CONSTRUCTORAS (Facturado: 34+35; Monto: 34+35+36)</td>
              <td className="money-cell"><MoneyInput value={data.cas037} onChange={(v) => set("cas037", v)} readOnly={readOnly} total testId="anexo-cas037" /></td>
              <td className="op">=</td>
              {M("cas137", true)}
            </tr>
            <tr>
              <td className="num">38</td>
              <td className="lbl total" colSpan={2}>OPERACIONES NO SUJETAS A ITBIS POR SERVICIOS DE CONSTRUCCIÓN</td>
              <td className="op">=</td>
              {M("cas138", true)}
            </tr>

            {/* Sección VII Comisionistas */}
            <tr>
              <td className="sec" colSpan={2}>VII. OPERACIONES DE COMISIONISTAS</td>
              <td className="sec" style={{ textAlign: "center" }}>TOTAL FACTURADO</td>
              <td className="sec"></td>
              <td className="sec" style={{ textAlign: "center" }}>MONTO</td>
            </tr>
            <tr>
              <td className="num">39</td>
              <td className="lbl">VENTAS DE BIENES POR COMISIÓN</td>
              <td className="money-cell"><MoneyInput value={data.cas039} onChange={(v) => set("cas039", v)} readOnly={readOnly} testId="anexo-cas039" /></td>
              <td className="op">+</td>
              {M("cas139")}
            </tr>
            <tr>
              <td className="num">40</td>
              <td className="lbl">VENTAS DE SERVICIOS EN NOMBRE DE TERCEROS</td>
              <td className="money-cell"><MoneyInput value={data.cas040} onChange={(v) => set("cas040", v)} readOnly={readOnly} testId="anexo-cas040" /></td>
              <td className="op">+</td>
              {M("cas140")}
            </tr>
            <tr>
              <td className="num">41</td>
              <td className="lbl total">TOTAL OPERACIONES COMISIONISTAS (Sumar Casillas 39+40)</td>
              <td className="money-cell"><MoneyInput value={data.cas041} onChange={(v) => set("cas041", v)} readOnly={readOnly} total testId="anexo-cas041" /></td>
              <td className="op">=</td>
              {M("cas141", true)}
            </tr>
            <tr>
              <td className="num">42</td>
              <td className="lbl total" colSpan={2}>OPERACIONES NO SUJETAS A ITBIS POR COMISIONES</td>
              <td className="op">=</td>
              {M("cas142", true)}
            </tr>

            {/* Sección VIII */}
            <tr><td className="sec" colSpan={5}>VIII. DATOS INFORMATIVOS — MONTO</td></tr>
            {SEC8.map(([n, label, op, monto]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className="lbl" colSpan={2}>{label}</td>
                <td className="op">{op}</td>
                {M(monto)}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Sección IX ITBIS PAGADO (4 columnas de monto) */}
        <table className="dgii-table" style={{ marginTop: 8 }}>
          <colgroup>
            <col style={{ width: "28px" }} />
            <col />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
          </colgroup>
          <tbody>
            <tr>
              <td className="sec" colSpan={2}>IX. ITBIS PAGADO</td>
              <td className="sec" style={{ textAlign: "center" }}>COMPRAS LOCALES</td>
              <td className="sec" style={{ textAlign: "center" }}>SERVICIOS</td>
              <td className="sec" style={{ textAlign: "center" }}>IMPORTACIONES</td>
              <td className="sec" style={{ textAlign: "center" }}>TOTAL</td>
            </tr>
            <tr><td className="sec" colSpan={6}>A) NO DEDUCIBLE (Llevado al Costo/Gasto)</td></tr>
            {SEC9_A.map(([n, label, c, s, im, tot, total]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className={`lbl ${total ? "total" : ""}`}>{label}</td>
                {M(c, total)}{M(s, total)}{M(im, total)}{M(tot, true)}
              </tr>
            ))}
            <tr><td className="sec" colSpan={6}>B) DEDUCIBLE</td></tr>
            {SEC9_B.map(([n, label, c, s, im, tot, total]) => (
              <tr key={n}>
                <td className="num">{n}</td>
                <td className={`lbl ${total ? "total" : ""}`}>{label}</td>
                {M(c, total)}{M(s, total)}{M(im, total)}{M(tot, true)}
              </tr>
            ))}
            <tr><td className="sec" colSpan={6}>C) ITBIS SUJETO A PROPORCIONALIDAD (Art. 349 del Código Tributario)</td></tr>
            <tr>
              <td className="num">53</td>
              <td className="lbl">ITBIS SUJETO A PROPORCIONALIDAD</td>
              {M("cas053")}{M("cas153")}{M("cas253")}{M("cas353", true)}
            </tr>
            <tr>
              <td className="num">54</td>
              <td className="lbl total" colSpan={4}>COEFICIENTE DE PROPORCIONALIDAD ((((Casillas 2+5+10 del IT1) / Casilla 1 del IT1)) * 100)</td>
              {M("cas154", true)}
            </tr>
            <tr>
              <td className="num">55</td>
              <td className="lbl total">ITBIS ADMITIDO POR APLICACIÓN DE PROPORCIONALIDAD (Casillas 53*54)</td>
              {M("cas055", true)}{M("cas155", true)}{M("cas255", true)}{M("cas355", true)}
            </tr>
            <tr>
              <td className="num">56</td>
              <td className="lbl total">TOTAL ITBIS DEDUCIBLE (52+55)</td>
              {M("cas056", true)}{M("cas156", true)}{M("cas256", true)}{M("cas356", true)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  );
}
